.scolab-switcher-loading-indicator {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: 20px;
    color: #98A1AF;
}

.scolab-switcher-loading-dots {
    display: inline-flex;
    align-items: center;
    gap: 3px;
}

.scolab-switcher-loading-dot {
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background: currentColor;
    animation: scolab-switcher-loading-pulse 1s ease-in-out infinite;
}

.scolab-switcher-loading-dot:nth-child(2) {
    animation-delay: 120ms;
}

.scolab-switcher-loading-dot:nth-child(3) {
    animation-delay: 240ms;
}

.scolab-switcher-loading-visually-hidden {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
}

@keyframes scolab-switcher-loading-pulse {
    0%, 80%, 100% {
        opacity: 0.35;
        transform: scale(0.8);
    }

    40% {
        opacity: 1;
        transform: scale(1.1);
    }
}

@media (prefers-reduced-motion: reduce) {
    .scolab-switcher-loading-dot {
        animation: none;
        opacity: 0.7;
        transform: none;
    }
}
